import { ProgressBarStatus } from '@core/enums/progress-bar-status.enum';
import { PlanningBoardSettings } from '@core/models/planning-board-settings';

export class PlanningProgressHelper {
  public static computeProgressPercentage(planningSettings: PlanningBoardSettings, value: number, maxValue: number) {
    //no capacity and entered any value means we are above 100%
    if (maxValue <= 0 && value > 0) {
      return planningSettings.lowAdequacyThreshold;
    }

    const rawPercentage = maxValue ? (100 * value) / maxValue : 0;
    return rawPercentage;
  }

  public static computeStatus(planningSettings: PlanningBoardSettings, percentage: number, hasUnassignedHours = true) {
    if (!percentage && !hasUnassignedHours) return ProgressBarStatus.Neutral;

    const { lowPlanningProgressThreshold, mediumPlanningProgressThreshold, highPlanningProgressThreshold } =
      planningSettings;

    if (percentage > highPlanningProgressThreshold) {
      return ProgressBarStatus.Good;
    } else if (percentage > mediumPlanningProgressThreshold) {
      return ProgressBarStatus.Warning;
    } else if (percentage > lowPlanningProgressThreshold) {
      return ProgressBarStatus.Error;
    }

    return ProgressBarStatus.Error;
  }
}
